const InfinityEnums = {
  Locale: {
    EN: 'en',
    AR: 'ar',
  },
  ChargingTokenType: {
    RFID: 'Rfid',
    VIRTUAL: 'Virtual',
  },
  InvitationStatus: {
    ACCEPTED: 'Accepted',
    REJECTED: 'Rejected',
    PENDING: 'Pending',
  },

  ChargingTokenStatus: {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
    DEACTIVATED: 'Deactivated',
  },
  ChargingLevel: {
    LEVEL1: 'Level 1',
    LEVEL2: 'Level 2',
    LEVEL3: 'Level 3',
  },
  TransactionStatus: {
    REVERSED: 'Reversed',
    CORRECTED: 'Corrected',
    NORMAL: 'Normal',
    VOID: 'Void',
  },
  TransactionReverseType: {
    REVERSE: 'Reverse',
    CORRECT: 'Correct',
  },
  PaymentStatus: {
    SUCCEED: 'success',
    FAILED: 'fail',
    PENDING: 'pending',
  },
  AdminActions: {
    Edit: 'Edit',
    Create: 'Create',
    Delete: 'Delete',
    Activate: 'Activate',
    Deactivate: 'Deactivate',
    Invite: 'Invite',
    Unblock: 'Unblock',
  },
  Models: {
    Admin: 'Admin',
    AdminRole: 'AdminRole',
    BillingAccount: 'BillingAccount',
    Country: 'Country',
    ExternalClient: 'ExternalClient',
    InviteUser: 'InviteUser',
    Notification: 'Notification',
    NotificationGroup: 'NotificationGroup',
    PaymentSession: 'PaymentSession',
    Point: 'Point',
    Transaction: 'Transaction',
    User: 'User',
    Voucher: 'Voucher',
    ChargingToken: 'ChargingToken',
  },
  IFFilterTitle: {
    Country: 'Country',
    Role: 'Role',
  },
  NotificationStatus: {
    SENT: 'Sent',
    SCHEDULED: 'Scheduled',
    CANCELLED: 'Cancelled',
  },
  UsersActivityDurations: {
    lastYear: 'lastYear',
    thisYear: 'thisYear',
    last6Months: 'last6Months',
    last3Months: 'last3Months',
    lastMonth: 'lastMonth',
    lastWeek: 'lastWeek',
  },
  AnalyticsFilter: {
    lastYear: 'lastYear',
    thisYear: 'thisYear',
    last6Months: 'last6Months',
    last3Months: 'last3Months',
    lastMonth: 'lastMonth',
    thisMonth: 'thisMonth',
  },
  UsersActivity: {
    lastYear: 'lastYear',
    thisYear: 'thisYear',
    last6Months: 'last6Months',
    last3Months: 'last3Months',
    lastMonth: 'lastMonth',
    lastWeek: 'lastWeek',
  },
}

export default InfinityEnums
